module.exports = __webpack_public_path__ + "img/tip3.c503065f.png";